import React, { useState } from 'react';
import useAddToCart from './AddToCartButton'; // Import the hook you created

const AddToCart = ({ product, setAddedToCart, setMessage }) => {
  const [quantity, setQuantity] = useState(1);
  const { handleAddToCart, loading, error } = useAddToCart(setMessage);

  const handleClick = () => {
    handleAddToCart(product.slug, quantity, () => {
      setAddedToCart(true);
      setMessage(`Added ${quantity} item(s) to the cart!`, 'success');
    });
  };

  return (
    <div>
      <div className="d-flex align-items-center mb-3">
        <label htmlFor="quantity" className="mr-2">Quantity:</label>
        <input
          type="number"
          id="quantity"
          min={1}
          value={quantity}
          onChange={(e) => setQuantity(parseInt(e.target.value))}
          disabled={loading}
          className="form-control w-25"
        />
      </div>

      <button 
        className="btn btn-success" 
        onClick={handleClick} 
        disabled={loading}
      >
        {loading ? 'Adding...' : 'Add to Cart'}
      </button>

      {error && <div className="alert alert-danger mt-2">{error}</div>}  {/* Display error message here */}
    </div>
  );
};

export default AddToCart;
